var exports = {
  "g": "negative__I8OSYV",
};

module.exports = exports;
